export default {
  recordState: null,
  recordingTime: 0,
  recordError: false,
  recordErrorMessage: null,
  recordRemainData: {},
  recordFileList: [],
  recordFileInstanceObj: {},
}
